<template>
  <div :class="$style.container">
    <!---header-->
    <Header v-if="(!noHeader.includes(this.$router.history.current.name))"/>
    <router-view :key="$route.fullPath"> </router-view>
    <!--- footer -->
    <Footer />
  </div>
</template>
<script>
import Header from '../Header';
import Footer from '../Footer';

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      noHeader: ['LandingLogin', 'CreatePassword', 'RecoveryPassword'],
    };
  },
};
</script>

<style lang="scss" module>
:root {
  --gray: rgba(3, 65, 112, 1);
  --blue: rgba(3, 91, 131, 1);
  --white: rgba(243, 250, 255, 1);
}

.container {
  span {
    box-sizing: border-box;
  }

  & .header {
    width: 100%;
    border-bottom: #0076cf solid 3px;

    & .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 1170px;
      margin: 0 auto;

      & .textHeader {
        padding-top: 10px;
        text-align: right;

        & div {
          display: inline-block;
          margin: 0 20px 10px;

          & .icons {
            & .img {
              margin-right: 5px;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }

  & .background {
    background-color: #035fa4;
    background-image: url('~@/assets/images/fondo2.svg');
    background-repeat: no-repeat;
  }

  & .backgroundColor {
    background: linear-gradient(276deg, rgba(3, 65, 112, 1) 51%, rgba(7, 117, 168, 1) 100%);
  }

  & .backgroundColorGrad {
    background: linear-gradient(180deg, var(--gray) 0%, var(--blue) 23%, var(--white) 23%);
  }

  & .textReforma {
    margin-top: 20px;
  }

  & .textLinkRetiro {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  & .afp {
    margin-top: 20px;
    margin-bottom: 50px;
  }

  & .footer {
    height: 85px;
    padding: 10px 0;
    background-color: #f6f6f6;

    & .footerContent {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 1170px;
      margin: 0 auto;

      & .contentSuper {
        text-align: left;

        & .logoSuper {
          float: left;
          height: 85px;
          margin-right: 30px;
        }

        & .textSuper {
          width: 100%;
          padding-top: 10px;
        }
      }
    }
  }
}

@media (min-width: 950px) and (max-width: 1199px) {
  .backgroundColorGrad {
    background: linear-gradient(180deg, var(--gray) 0%, var(--blue) 26%, var(--white) 26%);
  }

  .header {
    & .content {
      max-width: 850px;
    }
  }

  .footer {
    & .footerContent {
      max-width: 850px;

      & .contentSuper {
        & .textSuper {
          padding-top: 5px;
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 949px) {
  .backgroundColorGrad {
    background: linear-gradient(180deg, var(--gray) 0%, var(--blue) 24%, var(--white) 24%);
  }

  .header {
    & .content {
      padding: 5px 20px;
    }
  }

  .footer {
    & .footerContent {
      padding: 5px 20px;

      & .contentSuper {
        & .textSuper {
          padding-top: 5px;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .backgroundColorGrad {
    background: linear-gradient(180deg, var(--gray)  0%, var(--blue) 9%, var(--white) 9%);
  }

  .header {
    & .content {
      padding: 5px 20px;

      & div {
        flex-direction: row;
        margin-bottom: 0;
      }

      & .textHeader {
        text-align: right;

        & div {
          display: inline-block;
          margin-left: 15px;
        }
      }
    }
  }

  .footer {
    & .footerContent {
      padding: 5px 20px;

      & .contentSuper {
        & .textSuper {
          padding-top: 5px;
        }
      }
    }
  }
}

@media (max-width: 669px) {
  .backgroundColorGrad {
    background: linear-gradient(180deg, var(--gray) 0%, var(--blue) 12%, var(--white) 12%);
  }

  .header {
    & .content {
      padding: 5px 20px;

      & .logoCuprum {
        padding-top: 15px;
      }
    }
  }

  .footer {
    & .footerContent {
      padding: 5px 20px;

      & .contentSuper {
        & .textSuper {
          padding-top: 0;
        }
      }
    }
  }
}

@media (max-width: 549px) {
  .backgroundColorGrad {
    background: linear-gradient(180deg, var(--gray) 0%, var(--blue) 7%, var(--white) 7%);
  }

  .header {
    & .content {
      padding: 5px 20px;

      & .logoCuprum {
        padding-top: 0;
      }
    }
  }

  .footer {
    padding: 5px 0;

    & .footerContent {
      padding: 5px 20px;

      & .contentSuper {
        & .textSuper {
          padding-top: 0;
        }
      }
    }
  }
}

@media (max-width: 489px) {
  .backgroundColorGrad {
    background: linear-gradient(180deg, var(--gray) 0%, var(--blue) 7%, var(--white) 7%);
  }

  .header {
    & .content {
      padding: 5px 20px;

      & div {
        flex-direction: column;
        margin-bottom: 0;
      }

      & .logoCuprum {
        padding-top: 0;
        margin-bottom: 5px;
        text-align: center;
      }

      & .textHeader {
        display: none;
        text-align: center;

        & div {
          display: inline-block;
          margin-left: 15px;
        }
      }
    }
  }

  .footer {
    height: 155px;
    padding: 5px 0;

    & .footerContent {
      padding: 5px;

      & .contentSuper {
        text-align: center;

        & .logoSuper {
          width: 100%;
          height: 70px;
        }

        & .textSuper {
          width: 100%;
          padding-top: 5px;
        }
      }
    }
  }
}
</style>
